import React from "react";
import Breadcrumb from "../../../components/breadcrumb/Breadcrumb";

export default function Attic() {
  return (
    
    <div>
<Breadcrumb />
      <iframe
        height="1000px"
        name=" attic-vent"
        title="Attic"
        src="https://www.gaf.com/en-us/roofing-products/residential-roofing-products/ventilation-and-attic-vents?Action=GetGrid&amp;cbviewer=none"
        style={{ border: "none" }}
        width="100%"
      ></iframe>
    </div>
  );
}

